import template from './vehicle.html';
import controller from './vehicle.controller';

let vehicleComponent = {
    restrict: 'E',
    bindings: {},
    template,
    controller
};

export default vehicleComponent;
